if (!customElements.get("collection-load-more")) {
  class CollectionLoadMore extends HTMLElement {
    constructor() {
      super();

      this.pagesLoaded = 1;
      this.setProperties();

      window.addEventListener("shopify:section:load", () => {
        this.setProperties();
      });

      this.addEventListener("click", (e) => {
        const button = e.target.closest(".js-btn-load-more");
        if (!button || button !== this.btnLoadMore) return;

        e.preventDefault();
        this.btnLoadMore.setAttribute("disabled", true);
        this.loadMoreProducts();
      });

      document.addEventListener(
        "click",
        this.onProductLinkClick.bind(this),
        true
      );

      window.addEventListener("pageshow", this.onPageShow.bind(this));
    }

    setProperties() {
      this.productGrid = document.querySelector("#product-grid");
      this.btnLoadMore = this.querySelector(".js-btn-load-more");
      this.isLastPage = this.classList.contains("hidden");
    }

    onProductLinkClick(e) {
      const link = e.target.closest("#product-grid a[href]");
      if (!link) return;

      try {
        sessionStorage.setItem(
          "clm_scroll_state",
          JSON.stringify({
            collectionUrl: window.location.pathname + window.location.search,
            scrollY: window.scrollY,
            pagesLoaded: this.pagesLoaded,
          })
        );
      } catch (_) {}
    }

    onPageShow(event) {
      if (event.persisted) return;

      // 뒤로가기/앞으로가기 시에만 복원 (새로고침·직접방문 제외)
      const navEntry = performance.getEntriesByType("navigation")[0];
      if (navEntry && navEntry.type !== "back_forward") return;

      try {
        const raw = sessionStorage.getItem("clm_scroll_state");
        if (!raw) return;

        const state = JSON.parse(raw);
        const currentUrl = window.location.pathname + window.location.search;

        if (state.collectionUrl !== currentUrl) return;

        sessionStorage.removeItem("clm_scroll_state");
        this.restoreScrollState(state.pagesLoaded, state.scrollY);
      } catch (_) {}
    }

    async restoreScrollState(totalPages, scrollY) {
      this.style.visibility = "hidden";

      try {
        for (let page = 1; page < totalPages; page++) {
          if (this.isLastPage) break;
          await this.loadMoreProducts(true);
        }
      } finally {
        this.style.visibility = "";
      }

      // 레이아웃 재계산 완료 후 스크롤 (더블 rAF 패턴)
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.scrollTo(0, scrollY);
        });
      });
    }

    async loadMoreProducts(silent = false) {
      try {
        const nextPageUrl = this.btnLoadMore?.dataset.href;
        if (!this.productGrid || !this.btnLoadMore || !nextPageUrl) {
          throw new Error("Load more button is missing a next page link.");
        }

        const nextPageResponse = await fetch(nextPageUrl);
        if (!nextPageResponse.ok) {
          throw new Error(
            `Failed to load more products (${nextPageResponse.status}).`
          );
        }

        const nextPageText = await nextPageResponse.text();

        const nextPageHTML = new DOMParser().parseFromString(
          nextPageText,
          "text/html"
        );

        const productGrid = nextPageHTML.querySelector("#product-grid");
        const loadMoreContainer = nextPageHTML.querySelector(
          "collection-load-more"
        );
        const btnLoadMore =
          loadMoreContainer?.querySelector(".js-btn-load-more");

        if (!productGrid) {
          throw new Error("Could not find the next product grid.");
        }

        const isLoadMoreHidden = !loadMoreContainer
          || loadMoreContainer.classList.contains("hidden")
          || !btnLoadMore?.dataset.href;

        this.productGrid.insertAdjacentHTML("beforeend", productGrid.innerHTML);
        this.pagesLoaded++;

        if (isLoadMoreHidden) {
          this.isLastPage = true;
          this.classList.add("hidden");

          return;
        }

        this.btnLoadMore.dataset.href = btnLoadMore.dataset.href;
      } catch (error) {
        console.error(error);
        if (!silent) alert(error.message);
      } finally {
        this.btnLoadMore?.removeAttribute("disabled");
      }
    }
  }

  customElements.define("collection-load-more", CollectionLoadMore);
}
